import {AnyAction} from 'redux'

export const membersAreaEnabled = (state = false, action: AnyAction): boolean => {
  switch (action.type) {
    default:
      return state
  }
}
